import clearingnummer from '@opendevtools/clearingnummer';

/**
 * NB: Sweden only
 * @deprecated use the Resurs API instead!
 */
export const getBankNameByClearingNumber = (number: string | number) => {
    const clearingNumber = number.toString();
    if (clearingNumber.length < 4) {
        return '';
    }

    return clearingnummer.bankName(clearingNumber.replace(/\s/g, '') || '');
};
